import React from "react";
import { Config } from "@config/config";
import Activity from "./price/Activity";
import Transfer from "./price/Transfer";
import Hotel from "./price/Hotel";
import Flight from "./price/Flight";
import Package from "./price/Package";
import Car from "./price/Car";
const ListingPrice = ({
  t,
  mode,
  data,
productId,
  onStopSales,
  priceForm,
  service,
  profile,
}) => {
  const config = new Config(t);
  /*if (data.length === 0) {
    return;
  }*/
  const propsArray = {
    priceForm: priceForm,
    onStopSales: onStopSales,
    prices: data,
    t: t,
    productId:productId,
    config: config,
    profile: profile,
  };
  const composite = {
    activity: <Activity {...propsArray} />,
    transfer: <Transfer {...propsArray} />,
    hotel: <Hotel {...propsArray} />,
    package: <Package {...propsArray} />,
    flight: <Flight {...propsArray} />,
    car: <Car {...propsArray} />,
  };
  var component = composite[service];
  if (!component) {
    component = (
      <>
        <div className="container p-2">
          <div className="hero">
            <div className="px-4 py-5 my-5 text-center">
              <h3 className="display-5">
                <span>Loading error </span>
              </h3>
            </div>
          </div>
        </div>
      </>
    );
  }

  return <>{component}</>;
};
export default ListingPrice;
